import React, { useState, useEffect } from 'react';
import { Pagination } from "antd";
import Form from 'react-bootstrap/Form';

const PartnerResult = () => {
  const [resultData, setResultData] = useState([]); // Store the data from get_panswers.php
  const [questions, setQuestions] = useState([]); // Store the questions from get_presultquestions.php
  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const [pageSize, setPageSize] = useState(10); // Set the page size (items per page)
  const [errorMessage, setErrorMessage] = useState(''); // Store error messages

  // Fetch the questions dynamically from the API
  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await fetch('https://api.skepper.in/get_presultquestions.php');
        const data = await response.json();
        console.log('Fetched Questions:', data); // Debugging log
        if (data.success) {
          setQuestions(data.data); // Set the questions into state
        } else {
          console.error('Failed to fetch questions:', data.message);
        }
      } catch (error) {
        console.error('Error fetching questions:', error);
        setErrorMessage('Failed to fetch questions');
      }
    };

    fetchQuestions();
  }, []);

  // Fetch the answers dynamically from the API
  useEffect(() => {
    const fetchAnswers = async () => {
      try {
        const response = await fetch('https://api.skepper.in/get_panswers.php', {
          credentials: 'include', // Ensure credentials (cookies) are sent with the request
        });
        const data = await response.json();
        console.log('Fetched Answers:', data); // Debugging log
        if (data.success) {
          if (data.data.length === 0) {
            setErrorMessage('No answers found for the user'); // Custom error if no answers are found
          } else {
            setResultData(data.data); // Set the fetched answers into resultData
          }
        } else {
          console.error('Failed to fetch answers:', data.message);
          setErrorMessage(data.message || 'An error occurred while fetching answers');
        }
      } catch (error) {
        console.error('Error fetching answers:', error);
        setErrorMessage('An error occurred while fetching answers');
      }
    };

    fetchAnswers();
  }, []);

  // Handle page change
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  // Paginate the results based on the current page and page size
  const paginatedData = resultData.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return (
    <div>
      <div id="configtable" className="w-100 table-container pt-0 result_tab">
        {questions.length > 0 && resultData.length > 0 ? (
          <table className="responsive-table">
            <thead>
              <tr>
                <th>Date</th>
                {questions.map((question) => (
                  <th key={question.id}>{question.question}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((submission) => (
                  <tr key={submission.submission_id}>
                    <td>{new Date(submission.created_at).toLocaleDateString('en-GB')}</td>

                    {questions.map((question) => {
                      const answer = submission.answers?.find(ans => Number(ans.question_id) === Number(question.id));
                      return (
                        <td key={question.id}>
                          <div>{answer ? answer.answer : 'No answer'}</div>
                        </td>
                      );
                    })}
                  </tr>
                ))
              ) : (
                <tr className="no_data">
                  <td colSpan={questions.length + 1}>No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        ) : (
          <tr className="no_data">
            <td colSpan={questions.length + 1}>
              {errorMessage || 'Loading data...'}
            </td>
          </tr>
        )}
      </div>

      <div className="table_page">
        <div className="one">
          <span>Total: {resultData.length}</span>
        </div>
        <div className="two">
          <Pagination
            current={currentPage}
            total={resultData.length}
            pageSize={pageSize}
            onChange={handlePageChange}
          />
        </div>
        <div className="three">
          <div className="show_page">
            <p>Show Per Page</p>
            <div className="export_category">
              <div className="select_category">
                <Form.Select
                  aria-label="Show per page"
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                </Form.Select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerResult;
